import type {FC} from 'react'
import type {RegisteredRuleSchemaComponent} from '@github-ui/repos-rules/types/rules-types'
import {CheckIcon, XIcon} from '@primer/octicons-react'

export const defaultRegistry: Record<string, FC<RegisteredRuleSchemaComponent>> = {
  boolean: props => <SimpleField {...props} />,
  integer: props => <SimpleField {...props} />,
  string: props => <SimpleField {...props} />,
  array: props => <ArrayField {...props} />,
}

const SimpleField = ({field, value}: RegisteredRuleSchemaComponent) => {
  if (value === '') {
    return null
  }
  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div className="width-full d-flex flex-row align-items-center justify-content-between text-small gap-1">
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <span className="fgColor-muted flex-2">{field.display_name}</span>
      <div className="flex-1">
        {typeof value === 'boolean' &&
          (value ? (
            <CheckIcon className="color-fg-success" aria-label={`${field.display_name} is enabled`} />
          ) : (
            <XIcon className="color-fg-danger" aria-label={`${field.display_name} is disabled`} />
          ))}
        {(typeof value === 'string' || typeof value === 'number') && <pre>{value}</pre>}
      </div>
    </div>
  )
}

function ArrayField({field, value}: RegisteredRuleSchemaComponent) {
  if (!Array.isArray(value)) {
    return null
  }
  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div className="d-flex flex-column align-items-center justify-content-between text-small gap-1">
      <span className="fgColor-muted">{field.display_name}</span>
      <ul className="tmp-pl-3">
        {(value as string[]).map(item => {
          const stringifiedItem = typeof item === 'object' ? JSON.stringify(item) : item
          return <li key={stringifiedItem}>{stringifiedItem}</li>
        })}
        {value.length === 0 && <li className="color-fg-muted">None</li>}
      </ul>
    </div>
  )
}
